/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_BuildingInputs */

const cs_kn_building = /** @type {(inputs: Kn_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhledání budovy`)
};

const en_kn_building = /** @type {(inputs: Kn_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building lookup`)
};

/**
* | output |
* | --- |
* | "Building lookup" |
*
* @param {Kn_BuildingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_building = /** @type {((inputs?: Kn_BuildingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_BuildingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_building(inputs)
	return cs_kn_building(inputs)
});